module.exports = function() {
  return new Worker(__webpack_public_path__ + "5d24c360435c5abbc992.worker.js");
};